import React from "react";

const ReportIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 17V0H8.575L9.05 2.15H15V11.4H8.6L8.12668 9.275H1.5V17H0ZM9.875 9.9H13.5V3.65H7.775L7.3 1.5H1.5V7.775H9.4L9.875 9.9Z"
        fill={fill}
      />
    </svg>
  );
};

ReportIcon.defaultProps = {
  width: 15,
  height: 17,
  fill: "black",
};

export default ReportIcon;
